<template>
  <section id="about_me">
    <div class="h-screen">
      <div class="h-full flex flex-col justify-center">
        <div class="text-center mb-10 -mt-20 exp">
          <p>***</p>
          <p
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
            class="font-bold"
          >
            About Me
          </p>
        </div>
        <div
          class="
            md:grid md:place-items-center
            xl:place-items-start
            grid-cols-2
            xl:grid-cols-4 xl:gap-x-2
          "
        >
          <div class="xl:col-start-2">
            <img
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-anchor-placement="bottom-bottom"
              class="
                shadow-lg
                h-40
                md:h-40
                mx-auto
                md:mx-0
                object-contain
                lg:h-80
                rounded-lg
              "
              src="images/pk.jpg"
              alt=""
            />
          </div>
          <div class="m-3">
            <div
              class="md:flex md:space-x-3 grid grid-cols-2 place-items-center"
            >
              <div
                data-aos="fade-up"
                data-aos-duration="3000"
                data-aos-offset="0"
                :class="[
                  $root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg',
                ]"
                class="
                  flex flex-col
                  items-center
                  w-28
                  h-28
                  lg:w-36 lg:h-28
                  space-y-3
                  rounded-lg
                "
              >
                <svg
                  class="w-6 h-6 exp mt-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                  ></path>
                </svg>
                <span
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-xs lg:text-sm font-bold"
                  >Experience</span
                >
                <span
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-xs"
                  >Over 1 year</span
                >
              </div>
              <div
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-offset="300"
                :class="[
                  $root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg',
                ]"
                class="
                  flex flex-col
                  items-center
                  w-28
                  h-28
                  lg:w-36 lg:h-28
                  space-y-3
                  rounded-lg
                "
              >
                <svg
                  class="w-6 h-6 mt-3 exp"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                  ></path>
                </svg>
                <span
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-xs lg:text-sm font-bold"
                  >Screen Time</span
                >
                <span
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-xs"
                  >Anytime</span
                >
              </div>
              <div
                data-aos="fade-up"
                data-aos-duration="3000"
                :class="[
                  $root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg',
                ]"
                class="
                  mt-3
                  md:mt-0
                  col-span-2
                  flex flex-col
                  items-center
                  w-28
                  h-28
                  lg:w-36 lg:h-28
                  space-y-3
                  rounded-lg
                "
              >
                <svg
                  class="animate-ping w-6 h-6 mt-3 exp absolute"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  ></path>
                </svg>
                <svg
                  class="w-6 h-6 mt-3 exp"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  ></path>
                </svg>
                <span
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-xs lg:text-sm font-bold"
                  >Projects</span
                >
                <a
                  @click="toAlert()"
                  style="cursor: pointer"
                  class="text-xs text-blue-300 hover:text-indigo-500"
                  >click me</a
                >
              </div>
            </div>
            <p
              :class="[$root.isDarkMood ? 'text-slate-50' : 'text-gray-700']"
              class="
                mt-3
                text-xs
                md:text-md
                xl:text-lg
                text-center
                md:text-left
              "
            >
              Hello there! My name is Yell Yint Aung , a junior web developer. I
              create websites and webapps using Laravel , Vue and a little bit
              of react.
            </p>
            <div class="flex justify-center md:block mt-4">
              <a
                href="#contactMe"
                class="
                  about_me_btn
                  px-1
                  py-3
                  md:px-4 md:py-2
                  rounded-lg
                  font-bold
                  text-xs
                  md:text-sm
                "
              >
                Contact Me
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
  methods: {
    toAlert() {
      Swal.fire({
        title: "Hi THERE!",
        text: `My projects are in the blog section right now.Please go to the blogs section, I will upload my projects here in the future version.`,
        imageUrl: "https://unsplash.it/400/200",
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: "sorry, this is supposed to be an image",
      });
    },
  },
};
</script>

<style>
.swal2-styled.swal2-confirm{
  background-color: #6f7dcc;
}
/*  */
</style>